import GpsStampHistoryPage from './GpsStampHistoryPage';

export default GpsStampHistoryPage;
